































/* eslint-disable vue/prop-name-casing */
import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';

import BrandCard from '~/components/BrandCard/BrandCard.vue';
import CardSection from '~/components/CardSection/CardSection.vue';
import Container from '~/components/Container.vue';

interface ILink {
  cached_url: string;
  url: string;
}

interface IBrand {
  content: {
    logo: {
      filename: string;
      alt: string;
    };
  };
  slug: string;
}

export default defineComponent({
  name: 'BrandCarousel',
  components: {
    CardSection,
    BrandCard,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: Object as PropType<ILink>,
      default: () => ({}),
    },
    link_text: {
      type: String,
      default: '',
    },
    brands: {
      type: Array as PropType<IBrand[]>,
      default: () => [],
    },
  },
  setup(props) {
    const linkUrl = computed(() =>
      sanitizeLinkUrl(`${props.link.cached_url || props.link.url || ''}`),
    );
    const getBrandUrl = (slug: string) => {
      return `/brands/${slug}`;
    };
    return {
      linkUrl,
      getBrandUrl,
    };
  },
});
